export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Привітальний бонус"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Спробуй свою удачу!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви виграли"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Крутіть колесо і отримайте тестові кошти для вивчення всіх функцій платформи."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ці кошти призначені для тестування."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пориньте і випробуйте всі функції."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Крутити"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отримати"])}
}